<!-- eslint-disable no-unused-vars -->
<template>
  <b-card no-body>
    <b-table
      striped
      hover
      responsive
      class="position-relative"
      :items="dataTable"
      :fields="fields"
      empty-text="Không có dữ liệu"
      table-class="vgt-table cs-table-info"
    >
      <template #cell(STT)="data">
        {{ data.index + (currentPage - 1) * perPage + 1 }}
      </template>
      <template #cell(user)="data"> {{ data.item.createdBy }} </template>
      <template #cell(createdAt)="data">
        {{ new Date(data.value) | moment("DD/MM/YYYY HH:mm") }}
      </template>
      <template #cell(content)="data"> {{ data.item.contentLog }} </template>
    </b-table>
    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <!-- page length -->
      <b-form-group class="text-nowrap mb-md-0 mr-1">
        Hiển thị
        <label class="d-inline-flex align-items-center">
          <b-form-select
            id="perPageSelect"
            v-model="perPage"
            size="sm"
            inline
            :options="perPageOptions"
            @input="showPerPage"
          />
        </label>
        trên tổng số {{ totalRows }} dòng
      </b-form-group>

      <!-- pagination -->
      <div>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
          class="mb-0"
          @input="pagination"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  VBTooltip,
  BRow,
  BCol,
  BTable,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BCard,
  BButton,
  BCardBody,
  BFormCheckbox,
  BAvatar,
  BBadge,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { VueGoodTable } from "vue-good-table";
import useSetup from "./../useSetup";
import store from "@/store/index";
import { CanBoCongChucDelete as DeleteData } from "@/services/api/HoSoCanBoCongChuc/CanBoCongChucService";

export default {
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BTable,
    BCard,
    BCardBody,
    BButton,
    VueGoodTable,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BFormCheckbox,
    BAvatar,
    BBadge,
    BInputGroup,
    BInputGroupAppend,
  },
  props: {
    dataTable: {
      type: Array,
      required: true,
    },
    isLoaded: {
      type: Boolean,
      required: true,
    },
    searchRef: {
      type: Object,
      default: { value: "" },
    },
    totalRows: {
      type: Number,
      required: true,
    },
    dataMeta: { type: Object, required: true },
  },
  data() {
    return {
      isWait: false,
      // pageLength: 10,
      dir: false,

      searchTerm: "",

      //=======

      // perPage: 10,
      // pageOptions: [10, 20, 50],
      // totalRows: 1,
      // currentPage: 1,

      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      fields: [
        {
          key: "STT",
          label: "STT",
          thStyle: "text-align:center; width:50px",
        },
        {
          key: "user",
          label: "Tài khoản",
          sortable: true,
        },
        {
          key: "createdAt",
          label: "Thời gian",
          sortable: true,
        },
        {
          key: "collectionName",
          label: "Collection Name",
          thStyle: "text-align:center; ",
        },
        {
          key: "content",
          label: "Nội dung",
        },
        // {
        //   key: "ngaySinh",
        //   label: "Ngày sinh",
        //   thStyle: "text-align:center; width:150px",
        // },
        // {
        //   key: "phongBan",
        //   label: "Phòng ban",
        // },
        // {
        //   key: "action",
        //   label: "#",
        //   thStyle: "text-align:center; width:200px",
        //   tdClass: "d-flex justify-content-center",
        // },
      ],
    };
  },
  mounted() {
    // Set the initial number of items
    // this.totalRows = this.dataTable.length;
  },

  methods: {
    pagination(val) {
      // console.log("val", val);
      this.$emit("update-pagination", val);
    },
    showPerPage(val) {
      this.$emit("update-perpage", val);
    },
    search(val) {
      // console.log(val);
      this.$emit("update-searchquery", val);
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    // onFiltered(filteredItems) {
    //   // Trigger pagination to update the number of buttons/pages due to filtering
    //   this.totalRows = filteredItems.length;
    //   this.currentPage = 1;
    // },
    //--------

    showEdit(data) {
      // console.log("show-edit", data);
      this.$emit("show-edit", JSON.parse(JSON.stringify(data)));
    },

    showConfirmDeleteModule(data) {
      if (this.isWait) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Notification",
            icon: "CoffeeIcon",
            variant: "info",
            text: "In Progress",
          },
        });
      } else {
        this.$bvModal
          .msgBoxConfirm("Xác nhận xoá", {
            okTitle: "Đồng ý",
            cancelTitle: "Hủy",
            cancelVariant: "outline-secondary",
          })
          .then((value) => {
            if (value) {
              this.isWait = true;
              DeleteData({
                id: data.id,
              }).then((res) => {
                this.isWait = false;
                if (res.isError) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "Thất bại",
                      icon: "AlertTriangleIcon",
                      variant: "error",
                      text: res.message,
                    },
                  });
                } else {
                  this.$emit("remove-item", data);
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "Thành công",
                      icon: "CheckIcon",
                      variant: "success",
                      text: res.message,
                    },
                  });
                }
              });
            }
          });
      }
    },
  },
  setup(props, { emit }) {
    const {
      refListTable,
      perPage,
      currentPage,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
    } = useSetup();
    return {
      refListTable,
      perPage,
      currentPage,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,

      // dataTable,
      // dataTableIsLoaded,
      // searchTerm,
    };
  },
};
</script>
